import CabinetIcon from '../assets/cabinet';
import EncodingStationIcon from '../assets/encodingstation';
import ReaderIcon from '../assets/reader';
/*
import HammerIcon from '../assets/hammer';
import MiddlewareIcon from '../assets/logisticspc';

import EdgeServerIcon from '../assets/edgeServer';
import ForkliftIcon from '../assets/forklift';
//import ShelfIcon from '../assets/smartshelf';
*/

export const getIcon = type => types[type]['icon'];

// Key order is here same as displayed to user
export const types = {
  smartCabinet: {
    icon: CabinetIcon,
    subTypes: [
      'IF2',
      'IF3',
      'IF3Freezer',
      'IFG_3_0_S1_V1_EU',
      'IFG_3_0_R1S1_V1_EU',
      'IFZ_3_0_S1_V1_EU',
      'IFZ_3_0_R1S1_V1_EU',
      'IFG_3_0_S2_V1_EU',
      'IFG_3_0_R1S2_V1_EU',
      'IFZ_3_0_S2_V1_EU',
      'IFZ_3_0_R1S2_V1_EU',
    ],
  },
  encodingStation: {
    icon: EncodingStationIcon,
    subTypes: [],
  },
  selflyEncode: {
    icon: ReaderIcon,
    subTypes: [],
  },
};

// scale1 = smartshelf reader shelves (CDN shelf config, shelf identification, discovery)
const SCALE1_SUB_TYPES = [
  'IFG_3_0_S1_V1_EU',
  'IFG_3_0_R1S1_V1_EU',
  'IFZ_3_0_S1_V1_EU',
  'IFZ_3_0_R1S1_V1_EU',
];
// scale2 = device-weight-service lanes (tare and calibrate modes, planogram from the cabinet)
const SCALE2_SUB_TYPES = [
  'IFG_3_0_S2_V1_EU',
  'IFG_3_0_R1S2_V1_EU',
  'IFZ_3_0_S2_V1_EU',
  'IFZ_3_0_R1S2_V1_EU',
];
export const isScale1SubType = subType => SCALE1_SUB_TYPES.includes(subType);
export const isScale2SubType = subType => SCALE2_SUB_TYPES.includes(subType);

const OPTIONAL_SETTINGS = {
  SHELF_COUNT: ['IF2'],
  CARD_PAYMENT: types.smartCabinet.subTypes,
  // scale1 or hybrid rfid + scale1 cabinets pick a CDN shelf config; scale2 cabinets get their shelves
  // from the weight service, so they are excluded like rfid cabinets
  SHELF_CONFIG: types.smartCabinet.subTypes.filter(
    st => !['IF2', 'IF3', 'IF3Freezer'].includes(st) && !isScale2SubType(st)
  ),
};

export function hasOptionalSetting(subType, setting) {
  return OPTIONAL_SETTINGS[setting].includes(subType);
}
